import axios from 'axios';

// Si REACT_APP_API_URL est définie, on l'utilise toujours.
// Sinon, en dev on détecte l'IP du frontend et on tape sur le port 4010.
const getApiUrl = (): string => {
  const env = process.env.REACT_APP_API_URL;
  if (env) return env;
  const host = window.location.hostname;
  return `http://${host}:4010/api`;
};

const API_URL = getApiUrl();

export const getMembres = () =>
  axios.get(`${API_URL}/membres`).then(r => r.data);

export const getMembreById = (id: number) =>
  axios.get(`${API_URL}/membres/${id}`).then(r => r.data);

export const addMembre = (data: any) =>
  axios.post(`${API_URL}/membres`, data).then(r => r.data);

export const updateMembre = (id: number, data: any) =>
  axios.put(`${API_URL}/membres/${id}`, data).then(r => r.data);

export const deleteMembre = (id: number) =>
  axios.delete(`${API_URL}/membres/${id}`);

export const getAllRelations = () =>
  axios.get(`${API_URL}/relations`).then(r => r.data);

export const getRelations = (membreId: number) =>
  axios.get(`${API_URL}/relations/${membreId}`).then(r => r.data);

export const addRelation = (data: any) =>
  axios.post(`${API_URL}/relations`, data).then(r => r.data);

export const updateRelation = (id: number, data: any) =>
  axios.put(`${API_URL}/relations/${id}`, data).then(r => r.data);

export const deleteRelation = (id: number) =>
  axios.delete(`${API_URL}/relations/${id}`);
